import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const GeneralProductListingIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 17 15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.28271 3.19519C1.28271 2.62598 1.74415 2.16455 2.31336 2.16455H12.7717C13.3409 2.16455 13.8024 2.62599 13.8024 3.19519V4.44833H12.6024V3.36455H2.48271V13.7434H12.6024V12.8475H13.8024V13.9128C13.8024 14.482 13.3409 14.9434 12.7717 14.9434H2.31335C1.74415 14.9434 1.28271 14.482 1.28271 13.9128V3.19519ZM6.75387 5.2361C7.00002 5.45795 7.01973 5.83734 6.79788 6.08349L4.5752 8.5497L6.79788 11.0159C7.01972 11.2621 7.00002 11.6415 6.75386 11.8633C6.50771 12.0852 6.12832 12.0654 5.90648 11.8193L3.50995 9.16018C3.2003 8.81659 3.2003 8.28281 3.50996 7.93923L5.90648 5.28012C6.12833 5.03396 6.50772 5.01426 6.75387 5.2361ZM12.1307 5.2361C12.3769 5.01426 12.7562 5.03396 12.9781 5.28012L15.3746 7.93923C15.6843 8.28282 15.6843 8.81659 15.3746 9.16018L12.9781 11.8193C12.7562 12.0654 12.3769 12.0852 12.1307 11.8633C11.8846 11.6415 11.8648 11.2621 12.0867 11.0159L14.3094 8.5497L12.0867 6.08349C11.8648 5.83734 11.8845 5.45795 12.1307 5.2361ZM11.6736 6.20251C11.9198 6.42435 11.9395 6.80374 11.7177 7.04989L8.18779 10.9665C7.96594 11.2127 7.58656 11.2324 7.3404 11.0105C7.09425 10.7887 7.07454 10.4093 7.29639 10.1632L10.8263 6.24652C11.0481 6.00037 11.4275 5.98066 11.6736 6.20251Z"
          fill="#F7F9FD"
        />
      </SvgIcon>
    );
  })
);
